export default {
  blackLists: [],

  saleManagerDiscountLimits: [],

  saleManagerCredits: [],

  ordrSettings: [],

  orders: [],
  orderById: {},
  orderMaxCode: null,

  orderCartable: [],

  orderManagementCartable: [],

  orderPermitCartable: [],
  orderPermits: [],

  orderDraftCartable: [],
  orderDrafts: [],

  settlementTypes: [],
  settlementTypeCode: null,

  printLink: {},
};
